// let data = [];


export const makeGraphData = () => {
	let data = [];
	
	for (let i = 1; i < 51; i++) {
		let val = Math.floor(Math.random() * (256 - (-256)) + (-256));
		let val2 = Math.floor(Math.random() * (256 - (-256)) + (-256));
		data.push({sec: i, x: val, y: val2});
	}
	return data;
};

export const testPatientData = [
	{
		id: 1,
		name: 'JeongHun Youm',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-2, 1, 7, 3, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 2,
		name: 'Kildong Go',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [1, 1, -4, 9, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 3,
		name: 'Dooli',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-9, 2, -3, 8, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 4,
		name: 'Dounur',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-5, 2, -1, 3, 10],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 5,
		name: 'Micheal',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-2, 1, 7, 3, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 6,
		name: 'Hangil No',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [0, 1, 2, 3, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 7,
		name: 'Backwha Dong',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-9, 2, -3, 8, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 8,
		name: 'Gangi Lee',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [0, 1, 2, 3, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 9,
		name: 'Merong Lee',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [8, 1, -8, 4, -1],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 10,
		name: 'Harry Potter',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-5, 2, -1, 3, 10],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	},
	{
		id: 11,
		name: 'JeongHun Youm',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-2, 1, 7, 3, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 12,
		name: 'Kildong Go',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [1, 1, -4, 9, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 13,
		name: 'Dooli',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-9, 2, -3, 8, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 14,
		name: 'Dounur',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-5, 2, -1, 3, 10],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 15,
		name: 'Micheal',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-2, 1, 7, 3, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 16,
		name: 'Hangil No',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [0, 1, 2, 3, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 17,
		name: 'Backwha Dong',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-9, 2, -3, 8, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 18,
		name: 'Gangi Lee',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [0, 1, 2, 3, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 19,
		name: 'Merong Lee',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [8, 1, -8, 4, -1],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 20,
		name: 'Harry Potter',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-5, 2, -1, 3, 10],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	},
	{
		id: 21,
		name: 'JeongHun Youm',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-2, 1, 7, 3, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 22,
		name: 'Kildong Go',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [1, 1, -4, 9, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 23,
		name: 'Dooli',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-9, 2, -3, 8, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 24,
		name: 'Dounur',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-5, 2, -1, 3, 10],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 25,
		name: 'Micheal',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-2, 1, 7, 3, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 26,
		name: 'Hangil No',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [0, 1, 2, 3, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 27,
		name: 'Backwha Dong',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-9, 2, -3, 8, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 28,
		name: 'Gangi Lee',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [0, 1, 2, 3, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 29,
		name: 'Merong Lee',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [8, 1, -8, 4, -1],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 30,
		name: 'Harry Potter',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-5, 2, -1, 3, 10],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	},
	{
		id: 31,
		name: 'JeongHun Youm',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-2, 1, 7, 3, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 32,
		name: 'Kildong Go',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [1, 1, -4, 9, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 33,
		name: 'Dooli',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-9, 2, -3, 8, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 34,
		name: 'Dounur',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-5, 2, -1, 3, 10],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 35,
		name: 'Micheal',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-2, 1, 7, 3, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 36,
		name: 'Hangil No',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [0, 1, 2, 3, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 37,
		name: 'Backwha Dong',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-9, 2, -3, 8, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 38,
		name: 'Gangi Lee',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [0, 1, 2, 3, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 39,
		name: 'Merong Lee',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [8, 1, -8, 4, -1],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 40,
		name: 'Harry Potter',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-5, 2, -1, 3, 10],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	},
	{
		id: 41,
		name: 'JeongHun Youm',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-2, 1, 7, 3, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 42,
		name: 'Kildong Go',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [1, 1, -4, 9, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 43,
		name: 'Dooli',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-9, 2, -3, 8, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 44,
		name: 'Dounur',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-5, 2, -1, 3, 10],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 45,
		name: 'Micheal',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-2, 1, 7, 3, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 46,
		name: 'Hangil No',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [0, 1, 2, 3, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 47,
		name: 'Backwha Dong',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-9, 2, -3, 8, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 48,
		name: 'Gangi Lee',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [0, 1, 2, 3, 4],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 49,
		name: 'Merong Lee',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [8, 1, -8, 4, -1],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}, {
		id: 50,
		name: 'Harry Potter',
		age: '30',
		weight: '80kg',
		height: '180cm',
		gender: 'male',
		testdate: '2021-04-08 08:23:30',
		testtrialtime: '3days',
		markers: [-5, 2, -1, 3, 10],
		eofirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfirm: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		eofoam: makeGraphData(),
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
		ecfoam: makeGraphData()
		// [{type: "Forward", value: 30,}, {type: "Right", value: 93,},
		// {type: "Backward", value: 30,}, {type: "Left", value: 30,}],
	}
]
